export default "__VITE_ASSET__gzPjza4W__"